import { withTheme } from '@vebox/etui-system';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { Component, createElement } from 'react';
import { c as _defineProperty, _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '@vebox/etui-colors';
import { ErrorLabel } from '../ErrorLabel/ErrorLabel.js';
import { FormItem } from '../FormItem/FormItem.js';
import Input from '../Input/Input.js';
import InputLabel from '../InputLabel/InputLabel.js';

const _excluded = ["name", "label", "pattern", "defaultValue", "disabled", "onChange", "onClick", "readOnly", "styles", "startInputAddon", "endInputAddon", "size", "testId", "error"];
const isValueDefined = value => typeof value !== 'undefined' && value !== null && value !== '';
function fixControlledValue(value) {
  if (!isValueDefined(value)) {
    return '';
  }
  return value;
}
function resolveOnChange(target, e, onChange) {
  if (onChange) {
    let event = e;
    if (e.type === 'click') {
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      const originalInputValue = target.value;
      target.value = '';
      onChange(event);
      target.value = originalInputValue;
      return;
    }
    onChange(event);
  }
}
function instanceOfRefObject(ref) {
  return 'current' in ref;
}
class TextInput extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onFocus", e => {
      const {
        onFocus
      } = this.props;
      this.setState({
        focused: true
      });
      if (onFocus) {
        onFocus(e);
      }
    });
    _defineProperty(this, "onBlur", e => {
      const {
        onBlur
      } = this.props;
      this.setState({
        focused: false
      });
      if (onBlur) {
        onBlur(e);
      }
    });
    _defineProperty(this, "saveInput", input => {
      const {
        elRef
      } = this.props;
      if (elRef && instanceOfRefObject(elRef)) {
        this.input = elRef.current;
      } else {
        this.input = input;
      }
    });
    _defineProperty(this, "handleChange", e => {
      this.setValue(e.target.value);
      resolveOnChange(this.input, e, this.props.onChange);
    });
    const value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    this.state = {
      value,
      focused: false,
      // eslint-disable-next-line react/no-unused-state
      prevValue: value
    };
  }
  static getDerivedStateFromProps(nextProps, {
    prevValue
  }) {
    const newState = {
      prevValue: nextProps.value
    };
    if (nextProps.value !== undefined || prevValue !== nextProps.value) {
      newState.value = nextProps.value;
    }
    return newState;
  }
  setValue(value, callback) {
    if (this.props.value === undefined) {
      this.setState({
        value
      }, callback);
    }
  }
  render() {
    const _this$props = this.props,
      {
        name,
        label,
        pattern,
        defaultValue,
        disabled,
        onChange,
        onClick,
        readOnly,
        styles,
        startInputAddon,
        endInputAddon,
        size,
        testId,
        error
      } = _this$props,
      props = _objectWithoutProperties(_this$props, _excluded);
    const {
      value,
      focused
    } = this.state;
    const inputProps = _objectSpread2(_objectSpread2({}, props), {}, {
      id: name,
      name,
      value,
      pattern,
      defaultValue,
      disabled,
      readOnly,
      startInputAddon,
      endInputAddon,
      size,
      testId,
      onClick,
      onChange: this.handleChange,
      onFocus: this.onFocus,
      onBlur: this.onBlur
    });
    if (this.props.value !== undefined) {
      inputProps.value = fixControlledValue(value);
      // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      delete inputProps.defaultValue;
    }
    const hasValue = isValueDefined(inputProps.value) || isValueDefined(inputProps.defaultValue) || isValueDefined(this.state.value);
    return /*#__PURE__*/createElement(FormItem, _extends({
      readOnly: readOnly
    }, styles.root), label && /*#__PURE__*/createElement(InputLabel, _extends({
      shouldFloat: hasValue || focused,
      htmlFor: name,
      disabled: disabled,
      startInputAddon: startInputAddon,
      endInputAddon: endInputAddon,
      size: size
    }, styles.label), label), startInputAddon, /*#__PURE__*/createElement(Input
    // @ts-ignore
    , _extends({
      elRef: this.saveInput,
      label: label,
      error: error,
      testId: testId
    }, inputProps, styles.input)), error && /*#__PURE__*/createElement(ErrorLabel, null, error.errorMessage), endInputAddon);
  }
}
_defineProperty(TextInput, "defaultProps", {
  size: 'default',
  onChange: () => null,
  styles: {}
});
var TextInput$1 = withTheme(TextInput);

export default TextInput$1;
export { resolveOnChange };
